import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Apis } from "../../config";
import apiService from "../../services/ApiService";

const fetchWishListSaveItems = createAsyncThunk('wishlist/fetchWishListSaveItems', async (data, { rejectWithValue }) => {
    try {
        let response = await apiService.get(Apis.GetWishListSaveItems(data))
        return response
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch wish list items');
    }
});

export const wishListThunks = { fetchWishListSaveItems };

